import React, { useState, useEffect } from 'react';
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';
import SiteSurveyExtentionTable from './SiteSurveyExtensionTable';

const SiteSurveyExtentionsList = () => {
    const [extentionOrders,setExtentionOrders] = useState()
    const [loading,setLoading] = useState(false);

    const fetchExtentionOrders = async()=>{
        try {
            setLoading(true)
            const response = await axiosInstance.get('',{params:{sp:"usp_GetPendingSiteSurveyExtension"}});
            setExtentionOrders(response?.data?.Data)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(()=>{
        if(loading)return;
        fetchExtentionOrders();
    },[])

    return (
        <>
            <div className="page-content container-fluid">
               <div className="d-flex justify-content-between align-items-center ms-3">
                    <Breadcrumb title="Extensions" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Extentions", link: '#' }]} />
                </div>
                <SiteSurveyExtentionTable
                    List={extentionOrders}
                    loading={loading}
                    handleSubmit= {fetchExtentionOrders}
                />
            </div>
        </>
    );
};

export default SiteSurveyExtentionsList;
